// Tiny pub-sub for operational state changes.
// Used to refresh the live-status indicator and other listeners instantly
// after a mutation (block save/move/delete, weather update, crew change).
const listeners = new Set();

export function publishOps(event = "ops:refresh", detail) {
  listeners.forEach((fn) => {
    try { fn({ type: event, detail }); } catch (_) { /* noop */ }
  });
}

export function subscribeOps(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
